const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Preetam | Portfolio",
  description:
    "A Data Science practitioner who delineate in the financial market and leveraging into startups with AI based solutions and statstical analysis",
  og: {
    title: "Preetam Portfolio",
    type: "website",
  },
};

//Home Page
const greeting = {
  title: "Howdy!",
  sub: "Preetam",
  logo_name: "Preetam",
  resumeLink: "",
};

// home logos
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "white",
      },
      profileLink: "https://github.com/white07S",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "",
    },
{
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077b5",
      },
      profileLink: "https://l.facebook.com/l.php?u=https%3A%2F%2Flinkedin.com%2Fin%2Fpreetam-sharma-80350a194%3Ffbclid%3DIwAR11vcYkrEyBiypC6stP1h8ynd7DbQSwmZrCwRtiCSn3WyewqweeOY2RiGc&h=AT1pwGjEuYAxPMDyveq0RD1fOZvI0A9P7l8vN6kLGSuSQRpeANDsNjQhgNkW3pNcgOdtWR7ZfI6JXiivED4tojY4XCGwMRTZOgKlbAOhSMn9FtbDXebXjMkcd6e3",
    },
  ],
};

//what i do?
const skills = {
  data: [
    {
      title: "Data Science & Analysis",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production-ready models for various deep learning and statistical use cases",
        "⚡ Experienced in working with big data for its modelling and management",
        "⚡ Having good hands-on with Data Cleaning, processing & Analysing wth of Python, Julia, Tableau & PowerBI",
        "⚡ Experience with BCI's medical data and encoding",
        "⚡ Experience with openCV and NLP",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "SciPy",
          fontAwesomeClassname: "logos-numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "DigitalOcean",
          fontAwesomeClassname: "simple-icons:digitalocean",
          style: {
            backgroundColor: "transparent",
            color: "#0080FF",
          },
        
        },
        {
          skillName: "Apache Flink",
          fontAwesomeClassname: "simple-icons: apache_flink",
          style: {
            backgroundColor: "transparent",
            color: "#E6526F",
          },
        
        },
      ],
    },
    {
      title: "Fintech Modelling",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building and testing trading startgies for option and CFD's market",
        "⚡ Creating application for HFT's trades with automated trading system and integeration with real time market",
        "⚡ Stastical modelling, quant trading and fundamental analysis",
        "⚡ Portfolio optimzation and recovery formulation",
        "⚡ Hedge fund modelling and analysis",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Scipy",
          fontAwesomeClassname: "simple-icons:scipy",
          style: {
            color: "#8CAAE6",
          },
        },
        {
          skillName: "bitcoin",
          fontAwesomeClassname: "simple-icons:bitcoin",
          style: {
            color: "#F7931A",
          },
        },
        {
          skillName: "Deutsche Bank",
          fontAwesomeClassname: "simple-icons:deutschebank",
          style: {
            color: "#0018A8",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Barclays",
          fontAwesomeClassname: "simple-icons:barclays",
          style: {
            color: "#00AEEF",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "EEG circuit and Signal processing",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly affective EEG signal processing circuit.",
        "⚡ Customizing microcontrollers and PID's",
        "⚡ Signal Processing of medical data and specialised in EEG data",
        "⚡ Applying latest principle of BCI for Emotion detection with low latency",
      ],
      softwareSkills: [
        {
          skillName: "Octave",
          fontAwesomeClassname: "simple-icons:octave",
          style: {
            color: "#0790C0",
          },
        },
        {
          skillName: "Autodesk",
          fontAwesomeClassname: "simple-icons:autodesk",
          style: {
            color: "#0696D7",
          },
        },
        {
          skillName: "Arduino",
          fontAwesomeClassname: "simple-icons:arduino",
          style: {
            color: "#00979D",
          },
        },
        {
          skillName: "Selenium",
          fontAwesomeClassname: "simple-icons:selenium",
          style: {
            color: "#43B02A",
          },
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects, trading models and its deployment on cloud infrastructure.",
};

//project cards
// colors:[primary,secondary,success,danger,warning,info,light,dark,]
const projectcards = {
  list: [
    {
      title: "ForexFibonacci",
      img_path: "fib.gif",
      description:
        "A mathematical model for Fibonacci Retracement and location entry and exit formulation using ML",
      tags: [
        {
          lang: "Date: Inprogress",
          color: "#7CFC00",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "Scipy",
          color: "#ee4c2c",
        },
        {
          lang: "EURUSD",
          color: "#ff4a00",
        },

        
      ],
      link: "https://github.com/white07S/Forex-Fibonacci",
      code: "",
      linkcolor: "white",
    },
    {
      title: "ForexRL",
      img_path: "fo.gif",
      description:
        "A Deep Reinforcement Learning model for high volume and frequency Forex Portfolio Management ",
      tags: [
        {
          lang: "Date: July 30 2022",
          color: "#43c3d1",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "PyTorch",
          color: "#ee4c2c",
        },
        {
          lang: "AUDUSD",
          color: "#ff4a00",
        },
        {
          lang: "NZDUSD",
          color: "#820032",
        },
        
      ],
      link: "https://github.com/white07S/ForexRL",
      code: "",
      linkcolor: "white",
    },
    {
      title: "HFT-DQN",
      img_path: "hft.jpg",
      description:
        "A simple implementation of HFT (High-Frequency Trading) in Python on the concept of DQN for forex market ",
      tags: [
        {
          lang: "Date: July 12 2022",
          color: "#43c3d1",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "Scipy",
          color: "#3c0095",
        },
        {
          lang: "EURUSD",
          color: "#ff4a00",
        },
        {
          lang: "Tensorflow",
          color: "#820032",
        },
        
      ],
      link: "https://github.com/white07S/Forex-Trading",
      code: "",
      linkcolor: "white",
    },
    {
      title: "Black Scholes",
      img_path: "black.png",
      description:
        "Python implementation of Black Scholes formula for option pricing and tested on High Frequency data",
      tags: [
        {
          lang: "Date: July 01 2022",
          color: "#43c3d1",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "Scipy",
          color: "#3c0095",
        },
        {
          lang: "Binance",
          color: "#ff4b4b",
        },
        
      ],
      link: "https://github.com/white07S/Black-Scholes",
      code: "",
      linkcolor: "white",
    },
    {
      title: "Forex",
      img_path: "port.gif",
      description:
        "Real-time economic events analysis and bi directional forecast",
      tags: [
        {
          lang: "Date: April 30 2022",
          color: "#43c3d1",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "Tensorflow",
          color: "#820032",
        },
        {
          lang: "Selenium",
          color: "#00a100",
        },
        {
          lang: "Cassendra",
          color: "#ff4b4b",
        },
        {
          lang: "Apache Flink",
          color: "#3c0095",
        },
      ],
      link: "https://github.com/white07S/forex",
      code: "",
      linkcolor: "white",
    },
    {
      title: "Quanto",
      img_path: "project-02.gif",
      description:
        "A python platform for more than 30 different startgy testing and converting into real time",
      tags: [
        {
          lang: "Date: April 15 2022",
          color: "#43c3d1",
        },
        {
          lang: "Python",
          color: "red",
        },
        {
          lang: "C++",
          color: "blue",
        },
        {
          lang: "Trading view",
          color: "#ff4b4b",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },

    {
      title: "Sentilizer",
      img_path: "project-06.png",
      description:
        "A real-time sentiment analyizer of tweets, news and reddit post for stock market with 0.01 latency",
      tags: [
        {
          lang: "Date: April 01 2022",
          color: "#43c3d1",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "TextBlob",
          color: "#820032",
        },
        {
          lang: "Selenium",
          color: "#00a100",
        },
        {
          lang: "Cassendra",
          color: "#ff4b4b",
        },
        {
          lang: "Apache Flink",
          color: "#3c0095",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
     
    },

 
    {
      title: "Stockter",
      img_path: "neural.gif",
      description:
        "A webapp to visualize and filter stocks for day trading based on more than 30 differnt variable and its association rule.",
      tags: [
        {
          lang: "Date: March 25 2022",
          color: "#43c3d1",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "numpy",
          color: "#8700b0",
        },
        {
          lang: "matplotlib",
          color: "#c47206",
        },
        {
          lang: "Streamlit",
          color: "#ff4b4b",
        },
        {
          lang: "Heroku",
          color: "#3c0095",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
    {
      title: "Semantic Search APP",
      img_path: "project-03.png",
      description:
        "Demo of OpenAI's GPT-3 model on Semantic search using streamlit.",
      tags: [
        {
          lang: "Date: July 01 2022",
          color: "#43c3d1",
        },
        {
          lang: "ongoing",
          color: "red",
        },
        {
          lang: "Streamlit",
          color: "#ff4b4b",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
 
    {
      title: "Emotioly",
      img_path: "acti.gif",
      description:
        "A neural network model that process EEG signal and classify your emotions and its intensity",
      tags: [
        {
          lang: "Date: March 15 2022",
          color: "#43c3d1",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "matplotlib",
          color: "#c47206",
        },
        {
          lang: "Scipy",
          color: "#ff4b4b",
        },
        {
          lang: "C++",
          color: "#3c0095",
        },
      ],
      link: "",
      code: "",
      linkcolor: "white",
    },
  ],
};

const resumeleft = {
  left: {
    title: ["Experience"],
    data: [
      {
        title: "Start-up",
        subtitle: "Finterpreter",
        date: "March 2021 - present",
        content: [
          "Building a sophisticated trading and analysis system for investors and traders.",
          "Using multiple machine learning models with statistical capabilities to make correct predictions in real time for buying and selling",
          "Creating a recommendation system for financial market such as Stock, Forex and Cryptocurrencies.",
          "Using big-data processing, creating a real time HFT twitter, news and reddit sentiment analysis for financial market.",
          "Introducing multiple agents for buying and selling and getting better return (up to 3X) in comparison to S&P 500.",
          "Working on big data monitoring system for real time frequency data and making an centralised system for trading community with anonymity of user.",
        ],
      },
      {
        title: "Machine Learning",
        subtitle: "London Stock Exchange",
        date: "Nov 2020 - Feb 2021",
        content: [
          "Learned and gained experience in quant trading and options trading",
          "Introduced trading startgies by using genetic programming and deep learning",
          "Also had hands-on with real-time sentiment monetering.",
        ],
      },
      {
        title: "Euronext Paris Intern",
        subtitle: "CAC 30",
        date: "July 2020 - Oct 2020",
        content: [
          "Introducing statstical model for hedge fund management",
          "Used fbprophet and ARIMA for modelling differnet analysis",
        ],
      },
      {
        title: "EEG circuit modelling",
        subtitle: "Impherial College London",
        date: "Oct 2019 - April 2020",
        content: [
          "Learnt & applied various technique of modelling circuit modelling",
          "Had hands-on testing and simulation of LTspcice and Kicad",
          "Understood and applied multiple technique of testing the circuit in real market",
        ],
      },
    ],
  },
};

const resumeright = {
  right: [
    {
      title: ["Education"],
      data: [
        {
          title: "Artificial Intelligence",
          subtitle: "Poznan university of Technology",
          date: "2020 - 2023",
          content: ["Ongoing topics: LSTM, Cassendra, GAN's"],
        },
        {
          title: "Mathematical Finance with Aritificial Intelligence",
          subtitle: "Impherial College London",
          date: "2019 - 2023",
          content: ["Ongoing topics: Risk management, Recovery rate, Portfolio optimization"],
        },
        {
          title: "High School",
          date: "2004 - 2008",
          content: ["Computer Science with Mathematics"],
        },
      ],
    },
    {
      title: ["Ranks and Achivements"],
      data: [
        {
          title: "Ranks",
          content: [
            "#11/600 in Summer Analytics by London Stock Exchange",
            "#139/10065 in Google CodeJam by Google",
          ],
        },
        {
          title: "Achievements",
          content: [
            "Silver medal in best financial modelling by Euronext Paris Stock Exchange",
            "5⭐ Gold Badges for signal processing from ICL ",
            "Gold medal in State Badminton",
            "Silver medal in BCI's Research Bachelor",
          ],
        },
      ],
    },
    {
      title: ["Freelance Work"],
      data: [
        {
          title: "Scientific Confernece Website",
          subtitle: "",
          content: [
            "Created and hosted a website for a conference company from the UK",
          ],
        },
        {
          title: "Configuring a data pipeline for HFT data",
          subtitle: "",
          content: [
            "Built a personal pipeline for HFT data using cassendra and flink",
          ],
        },
      ],
    },
  ],
};

//certificate cards
const certifications = {
  certifications: [
    {
      title: "Tableau Analyst",
      subtitle: "Tableau",
      logo_path: "tabana-01.png",
      certificate_link:
        "#",
      alt_name: "Tableau",
      color_code: "#000000",
    },
    {
      title: "Tableau Consumer",
      subtitle: "Tableau",
      logo_path: "tabcon-01.png",
      certificate_link:
        "#",
      alt_name: "Tableau",
      color_code: "#000000",
    },
    {
      title: "Problem solving",
      subtitle: "HackerRank",
      logo_path: "problem-01.png",
      certificate_link: "#",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Python",
      subtitle: "HackerRank",
      logo_path: "python-01.png",
      certificate_link: "#",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Certificate of Signal processing",
      subtitle: "Summer Analytics | ICL London",
      logo_path: "icl.jpg",
      certificate_link:
        "#",
      alt_name: "IITG",
      color_code: "#000000",
    },
    {
      title: "Tableau Desktop Qualified Associate",
      subtitle: "SimpliLearn",
      logo_path: "simplilearn-01.png",
      certificate_link:
        "",
      alt_name: "Simplilearn",
      color_code: "#000000",
    },
    {
      title: "London Stock Exchange",
      subtitle: "Best Intern",
      logo_path: "lse.png",
      certificate_link:
        "",
      alt_name: "Udemy",
      color_code: "#000000",
    },
    {
      title: "Machine Learning",
      subtitle: "Stanford University",
      logo_path: "coursera-01.png",
      certificate_link:
        "",
      alt_name: "Stanford University",
      color_code: "#000000",
    },
    {
      title: "Data Visualization",
      subtitle: "University of Michigan",
      logo_path: "coursera-01.png",
      certificate_link:
        "",
      alt_name: "University of Michigan",
      color_code: "#000000",
    },
    {
      title: "Euronext Paris",
      subtitle: "Financial Modelling",
      logo_path: "paris.png",
      certificate_link:
        "",
      alt_name: "DataCamp",
      color_code: "#000000",
    },
    {
      title: "Google",
      subtitle: "HashCode",
      logo_path: "google2.jpg",
      certificate_link:
        "",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
    {
      title: "Tableau Masters",
      subtitle: "iNeuron.ai",
      logo_path: "ineuron-01.png",
      certificate_link:
        "",
      alt_name: "HackerRank",
      color_code: "#000000",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, Trading, Cloud and Circuit modelling.",
  },
  addressSection: {
    title: "Address",
    subtitle: "Old Trafford, Manchester UK",
    link:"https://goo.gl/maps/opy3xKT51oucbikJ9",
  },
  phoneSection: {
    title: "Email",
    subtitle: "sharmapreetam.uk@outlook.com",
  },
};

//contact icons
const socialMediaLinks = [
  {
    name: "Github",
    link: "",
    iconifyClassname: "simple-icons:hackerrank",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#ffffff", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sharmapreetam.uk@outlook.com.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  projectsHeader,
  contactPageData,
  projectcards,
  certifications,
  resumeleft,
  resumeright,
};
